export default class Feedback {
  name = null;

  phone = null;
  
  email = null;
  
  message = null;
  
  agreement = null;
  
  files = [];

  constructor (data) {
    if (!data) return;

    this.name = data.name;
    this.phone = data.phone;
    this.email = data.email;
    this.message = data.message;
    this.agreement = data.agreement;
    this.files = data.files || [];
  }

  get formData () {
    const formData = new FormData();

    const {
      name,
      email,
      phone,
      files,
      message,
    } = this;

    formData.append('fullName', name);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('message', message);
    
    files.forEach(file => {
      formData.append('files[]', file);
    });

    return formData;
  }
}